import { camelCase } from 'lodash';

export const normaliseBenchmarkName = (name: string) => camelCase(name).replace('Benchmark', '');
